module.exports = __webpack_public_path__ + "images/icon_user.svg?2f4b0a04ddb5f3d2b0f03e3971d2e323";